import { createTheme } from "@mui/material/styles";

//Base Typography Class Updates
export const themeBase = createTheme({
  typography: {
    h1: {
      fontSize: 48,
    },
    h2: {
      fontSize: 40,
    },
    h3: {
      fontSize: 32,
    },
    h4: {},
    h5: {
      fontSize: 19,
      fontWeight: 600,
    },
    h6: {
      fontSize: 16,
      fontWeight: 700,
    },
    body1: {
      fontSize: 14, 
    },
    body2: {
      fontSize: 12, 
    },

    button: {
      fontWeight: 700, 
    },
  },
  palette: {
    primary: {
      main: '#11D6DF', // Maroon
    },
    secondary: {
      main: '#d4920f', // red color from mockups
      // '#4e5ba6' --> dark blue with grey
      // #c11674 --> pink purpule ish
    },
    background: {
      default: '#F5F5F5', // Light Gray
    },
    text: {
      primary: '#333333', // Dark Gray
      secondary: '#cccccc', // White
    },
  }
});

//////////////////////////////////////////////////////////
//University of California, Irvine
//Brand Guide: https://brand.uci.edu
//////////////////////////////////////////////////////////

/*const uciHeadingFontFamily = '"Montserrat Bold", "Montserrat", "Roboto Slab", "Arial", "sans-serif"';
const uciBodyFontFamily = '"Montserrat Regular", "Montserrat", "Hepta Slab", "Arial", "sans-serif"';*/
const uciHeadingFontFamily = '"Anton", "Oswald", "Roboto Slab", "Arial", "sans-serif"';
const uciBodyFontFamily = '"Roboto Mono", "Courier New", "Hepta Slab", "Arial", "sans-serif"';
export const themeUCI = createTheme({
  typography: {
    fontFamily: [
      "Monserrat",
      "Hepta Slab",
      "Arial",
      "sans-serif",
    ].join(","),
    h1: {
      fontFamily: uciHeadingFontFamily,
      fontSize: themeBase.typography.h1.fontSize,
      fontWeight: themeBase.typography.h1.fontWeight,
    },
    h2: {
      fontFamily: uciHeadingFontFamily,
      fontSize: themeBase.typography.h2.fontSize,
      fontWeight: themeBase.typography.h2.fontWeight,
    },
    h3: {
      fontFamily: uciHeadingFontFamily,
      fontSize: themeBase.typography.h3.fontSize,
      fontWeight: themeBase.typography.h3.fontWeight,
    },
    h4: {
      fontFamily: uciHeadingFontFamily,
      fontSize: themeBase.typography.h4.fontSize,
      fontWeight: themeBase.typography.h4.fontWeight,
    },
    h5: {
      fontFamily: uciHeadingFontFamily,
      fontSize: themeBase.typography.h5.fontSize,
      fontWeight: themeBase.typography.h5.fontWeight,
    },
    h6: {
      fontFamily: uciHeadingFontFamily,
      fontSize: themeBase.typography.h6.fontSize,
      fontWeight: themeBase.typography.h6.fontWeight,
    },
    // subtitle1: {},
    // subtitle2: {},
    body1: {
      fontFamily: uciBodyFontFamily,
      fontWeight: themeBase.typography.body1.fontWeight,
    },
    body2: {
      fontFamily: uciBodyFontFamily,
      fontWeight: themeBase.typography.body2.fontWeight,
    },
    button: {
      fontFamily: uciBodyFontFamily,
      fontWeight: themeBase.typography.button.fontWeight,
    },
    // caption: {},
    // overline: {},
  },
  palette: {
    primary: {
      main: "#255799",
      contrastText: '#fecc07'
      // light: will be calculated from palette.primary.main,
      // dark: will be calculated from palette.primary.main,
      // contrastText: will be calculated to contrast with palette.primary.main
    },
    secondary: {
      main: "#fecc07",
      // light: will be calculated from palette.secondary.main,
      // dark: will be calculated from palette.secondary.main,
      contrastText: "#255799", //will be calculated to contrast with palette.secondary.main
    },
    // error: {},
    // warning: {},
    // info: {},
    // success: {},
  },
  components: {
    MuiInputBase: {
      styleOverrides: {
        root: {
          //height: "51px",
        },
      },
    },
  },
});

//////////////////////////////////////////////////////////
//Loyola Marymount University
//Brand Guide: https://brand.lmu.edu/identitystandards/
//////////////////////////////////////////////////////////

const lmuHeadingFontFamily = '"Metric", "Arial"';
const lmuBodyFontFamily = '"Lyon", "Georgia"'; 
export const themeLMU = createTheme({
  typography: {
    fontFamily: [
      "Metric",
      "Lyon",
      "Arial",
      "Georgia",
      "sans-serif",
    ].join(","),
    h1: {
      fontFamily: lmuHeadingFontFamily, 
      fontSize: themeBase.typography.h1.fontSize,
      fontWeight: themeBase.typography.h1.fontWeight,
    },
    h2: {
      fontFamily: lmuHeadingFontFamily,
      fontSize: themeBase.typography.h2.fontSize,
      fontWeight: themeBase.typography.h2.fontWeight,
    },
    h3: {
      fontFamily: lmuHeadingFontFamily,
      fontSize: themeBase.typography.h3.fontSize,
      fontWeight: themeBase.typography.h3.fontWeight,
    },
    h4: {
      fontFamily: lmuHeadingFontFamily,
      fontSize: themeBase.typography.h4.fontSize,
      fontWeight: themeBase.typography.h4.fontWeight,
    },
    h5: {
      fontFamily: lmuHeadingFontFamily,
      fontSize: themeBase.typography.h5.fontSize,
      fontWeight: themeBase.typography.h5.fontWeight,
    },
    h6: {
      fontFamily: lmuHeadingFontFamily,
      fontSize: themeBase.typography.h6.fontSize,
      fontWeight: themeBase.typography.h6.fontWeight,
    },
    // subtitle1: {},
    // subtitle2: {},
    body1: {
      fontFamily: lmuBodyFontFamily,
      fontSize: themeBase.typography.body1.fontSize,
      fontWeight: themeBase.typography.body1.fontWeight,
    },
    body2: {
      fontFamily: lmuBodyFontFamily,
      fontSize: themeBase.typography.body2.fontSize,
      fontWeight: themeBase.typography.body2.fontWeight,
    },
    button: {
      fontFamily: lmuBodyFontFamily,
      fontSize: themeBase.typography.button.fontSize,
      fontWeight: themeBase.typography.button.fontWeight,
    },
    // caption: {},
    // overline: {},
  },
  palette: {
    primary: {
      main: "#AB0C2F",
      // light: will be calculated from palette.primary.main,
      // dark: will be calculated from palette.primary.main,
      // contrastText: will be calculated to contrast with palette.primary.main
    },
    secondary: {
      main: "#0076A5",
      // light: will be calculated from palette.secondary.main,
      // dark: will be calculated from palette.secondary.main,
      // contrastText: will be calculated to contrast with palette.secondary.main
    },
    // error: {},
    // warning: {},
    // info: {},
    // success: {},
  },
  components: {
    MuiInputBase: {
      styleOverrides: {
        root: {
          //height: "51px",
        },
      },
    },
  },
});

//////////////////////////////////////////////////////////
//UC Santa Barbara
//Brand Guide: https://ucsb.app.box.com/v/visual-identity-guidelines
//////////////////////////////////////////////////////////

const ucsbHeadingFontFamily = '"Produkt", "Avenir Black", "Century Gothic", "Arial", "sans-serif"';
const ucsbBodyFontFamily = '"Avenir Light", "Century Gothic", "Arial", "sans-serif"';
export const themeUCSB = createTheme({
  typography: {
    fontFamily: [
      "Century Gothic",
      "Arial",
      "Inter", //Inter is a google font; May need to be imported https://fonts.google.com/specimen/Inter
      "Lato", //Lato is the stock MUI font, may not need to be imported?
      "sans-serif",
    ].join(","),
    h1: {
      fontFamily: ucsbHeadingFontFamily, 
      fontSize: themeBase.typography.h1.fontSize,
      fontWeight: themeBase.typography.h1.fontWeight,
    },
    h2: {
      fontFamily: ucsbHeadingFontFamily,
      fontSize: themeBase.typography.h2.fontSize,
      fontWeight: themeBase.typography.h2.fontWeight,
    },
    h3: {
      fontFamily: ucsbHeadingFontFamily,
      fontSize: themeBase.typography.h3.fontSize,
      fontWeight: themeBase.typography.h3.fontWeight,
    },
    h4: {
      fontFamily: ucsbHeadingFontFamily,
      fontSize: themeBase.typography.h4.fontSize,
      fontWeight: themeBase.typography.h4.fontWeight,
    },
    h5: {
      fontFamily: ucsbHeadingFontFamily,
      fontSize: themeBase.typography.h5.fontSize,
      fontWeight: themeBase.typography.h5.fontWeight,
    },
    h6: {
      fontFamily: ucsbHeadingFontFamily,
      fontSize: themeBase.typography.h6.fontSize,
      fontWeight: themeBase.typography.h6.fontWeight,
    },
    // subtitle1: {},
    // subtitle2: {},
    body1: {
      fontFamily: ucsbBodyFontFamily,
      fontWeight: themeBase.typography.body1.fontWeight,
    },
    body2: {
      fontFamily: ucsbBodyFontFamily,
      fontWeight: themeBase.typography.body2.fontWeight,
    },
    button: {
      fontFamily: ucsbBodyFontFamily,
      fontWeight: themeBase.typography.button.fontWeight,
    },
    // caption: {},
    // overline: {},
  },
  palette: {
    primary: {
      main: "#003660",
      contrastText: '#FEBC11'
    },
    secondary: {
      main: "#FEBC11",
      contrastText: "#fff",
    },
    // error: {},
    // warning: {},
    // info: {},
    // success: {},
  },
  components: {
    MuiInputBase: {
      styleOverrides: {
        root: {
          //height: "51px",
        },
      },
    },
  },
});

//////////////////////////////////////////////////////////
//Bakersfield College
//Brand Guide: https://www.bakersfieldcollege.edu/about/marketing/logo.html
//////////////////////////////////////////////////////////

const bcHeadingFontFamily = "RobotoSlab-Regular";
const bcBodyFontFamily = "Roboto";
export const themeBC = createTheme({
  typography: {
    fontFamily: [
      "Roboto",
      "Arial",
      "Inter", //Inter is a google font; May need to be imported https://fonts.google.com/specimen/Inter
      "Lato", //Lato is the stock MUI font, may not need to be imported?
      "sans-serif",
    ].join(","),
    h1: {
      fontFamily: bcHeadingFontFamily,
      fontSize: themeBase.typography.h1.fontSize,
      fontWeight: themeBase.typography.h1.fontWeight,
    },
    h2: {
      fontFamily: bcHeadingFontFamily,
      fontSize: themeBase.typography.h2.fontSize,
      fontWeight: themeBase.typography.h2.fontWeight,
    },
    h3: {
      fontFamily: bcHeadingFontFamily,
      fontSize: themeBase.typography.h3.fontSize,
      fontWeight: themeBase.typography.h3.fontWeight,
    },
    h4: {
      fontFamily: bcHeadingFontFamily,
      fontSize: themeBase.typography.h4.fontSize,
      fontWeight: themeBase.typography.h4.fontWeight,
    },
    h5: {
      fontFamily: bcHeadingFontFamily, 
      fontSize: themeBase.typography.h5.fontSize,
      fontWeight: themeBase.typography.h5.fontWeight,
    },
    h6: {
      fontFamily: bcHeadingFontFamily,
      fontSize: themeBase.typography.h6.fontSize,
      fontWeight: themeBase.typography.h6.fontWeight,
    },
    // subtitle1: {},
    // subtitle2: {},
    body1: {
      fontFamily: bcBodyFontFamily,
      fontWeight: themeBase.typography.body1.fontWeight,
    },
    body2: {
      fontFamily: bcBodyFontFamily,
      fontWeight: themeBase.typography.body2.fontWeight,
    },
    button: {
      fontFamily: bcBodyFontFamily,
      fontWeight: themeBase.typography.button.fontWeight,
    },
    // caption: {},
    // overline: {},
  },
  palette: {
    primary: {
      main: "#d4920f", // Bakersfield Red
      light: "#E25155", // Red 500 for buttons
      contrastText: "white", // Light pink
    },
    secondary: {
      main: "#fff", // Blue grey
      contrastText: "#fff",
    },
    error: {
      main: "#C11574", // Pink 700 from Untitled UI for error-like indications
    },
    warning: {
      main: "#F9C7D9", // Optional: Light pink for warnings
    },
    info: {
      main: "#4E5BA6", // Blue Gray 500 for informational elements
    },
    success: {
      main: "#50C878", // Optional: Green for success indications
    },
    // icon: {
    //   pink: "#C11574", // Pink 700 for icon bullets
    //   pinkLight: "#FEF6FB", // Pink 25 for icon backgrounds
    // },
  },
  components: {
    MuiInputBase: {
      styleOverrides: {
        root: {
          //height: "51px",
        },
      },
    },
  },
});


export const themeK12One = createTheme({
  typography: {
    fontFamily: [
      "Arial",
      "Inter", //Inter is a google font; May need to be imported https://fonts.google.com/specimen/Inter
      "Lato", //Lato is the stock MUI font, may not need to be imported?
      "sans-serif",
    ].join(","),
    h1: {
      fontFamily: uciHeadingFontFamily,
      fontSize: themeBase.typography.h1.fontSize,
      fontWeight: themeBase.typography.h1.fontWeight,
    },
    h2: {
      fontFamily: uciHeadingFontFamily,
      fontSize: themeBase.typography.h2.fontSize,
      fontWeight: themeBase.typography.h2.fontWeight,
    },
    h3: {
      fontFamily: uciHeadingFontFamily,
      fontSize: themeBase.typography.h3.fontSize,
      fontWeight: themeBase.typography.h3.fontWeight,
    },
    h4: {
      fontFamily: uciHeadingFontFamily,
      fontSize: themeBase.typography.h4.fontSize,
      fontWeight: themeBase.typography.h4.fontWeight,
    },
    h5: {
      fontFamily: uciHeadingFontFamily, //Roboto is a Google Font; May need to be imported https://fonts.google.com/specimen/Roboto+Slab
      fontSize: themeBase.typography.h5.fontSize,
      fontWeight: themeBase.typography.h5.fontWeight,
    },
    h6: {
      fontFamily: uciHeadingFontFamily,
      fontSize: themeBase.typography.h6.fontSize,
      fontWeight: themeBase.typography.h6.fontWeight,
    },
    body1: {
      fontFamily: uciBodyFontFamily,
      fontWeight: themeBase.typography.body1.fontWeight,
    },
    body2: {
      fontFamily: uciBodyFontFamily,
      fontWeight: themeBase.typography.body2.fontWeight,
    },
    button: {
      fontFamily: uciBodyFontFamily,
      fontWeight: themeBase.typography.button.fontWeight,
    },
  },
  palette: {
    primary: {
      main: "#0064A4",
      dark: "#003660",
      contrastText: "#E99245",
    },
    secondary: {
      main: "#E99245",
      contrastText: "#0064A4", //will be calculated to contrast with palette.secondary.main
    },
  },
  // components: {
  //   MuiInputBase: {
  //     styleOverrides: {
  //       root: {
  //         height: "51px",
  //       },
  //     },
  //   },
  // },
});
